var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFollowupBalck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2159_18877",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2159_18877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0168 14.3333V13.3333H12.4668C12.5113 13.3333 12.5557 13.3111 12.6002 13.2667C12.6446 13.2222 12.6668 13.1778 12.6668 13.1333V6.86666H3.3335V9.5H2.3335V4.2C2.3335 3.86666 2.45016 3.58333 2.6835 3.35C2.91683 3.11666 3.20016 2.99999 3.5335 2.99999H4.46683V1.58333H5.4835V2.99999H10.5335V1.58333H11.5335V2.99999H12.4668C12.8002 2.99999 13.0835 3.11666 13.3168 3.35C13.5502 3.58333 13.6668 3.86666 13.6668 4.2V13.1333C13.6668 13.4667 13.5502 13.75 13.3168 13.9833C13.0835 14.2167 12.8002 14.3333 12.4668 14.3333H10.0168ZM5.3335 15.7667L4.6335 15.0667L6.51683 13.1667H0.833496V12.1667H6.51683L4.6335 10.2667L5.3335 9.56666L8.4335 12.6667L5.3335 15.7667Z",
    fill: "#3E3E53"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowupBalck);
export default __webpack_public_path__ + "static/media/followup-balck.0b0e6799c8e000db9bf702a31e3aecb8.svg";
export { ForwardRef as ReactComponent };